/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useCallback } from "react";
import { View } from "react-native";
import {
  ReactFacebookLoginInfo,
  ReactFacebookFailureResponse,
} from "react-facebook-login";
import { TokenResponse } from "@react-oauth/google";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { BackButton } from "UpduoLibrary";
import { skalePrimaryBlue } from "config/UpduoColors";
import InternalIdView from "./StartViews/InternalIdView";
import GoogleView from "./StartViews/GoogleView";
import Auth0View from "./StartViews/Auth0View";
import SignupLoginView from "./StartViews/SignupLoginView";

interface SwitchPaneProps {
  isLoading: boolean;
  onBack: Function;
  onSubmitInternalId: Function;
  onSignupPress: Function;
  onLoginPress: Function;
  onFacebookPress?: (
    response: ReactFacebookLoginInfo | ReactFacebookFailureResponse
  ) => void;
  onGooglePress?: (response: TokenResponse) => void;
  onAuth0Press: Function;
  onSalesforcePress: Function;
  hasError: boolean;
  loginValidationText: string;
  isLoginInProgress: boolean;
  emailValidationText: string;
  passwordValidationText: string;
}

export default function SwitchPane({
  isLoading,
  onBack,
  onSubmitInternalId,
  onSignupPress,
  onLoginPress,
  onFacebookPress,
  onGooglePress,
  onAuth0Press,
  onSalesforcePress,
  hasError,
  loginValidationText,
  isLoginInProgress,
  emailValidationText,
  passwordValidationText,
}: SwitchPaneProps) {
  const startObject = useSelector((state: RootState) => state.startObject);

  const _handleShowContent = useCallback(() => {
    switch (startObject?.orgJoinRule) {
      case "E":
        return (
          <InternalIdView
            isLoading={isLoading}
            onSubmitInternalId={onSubmitInternalId}
            hasError={hasError}
          />
        );
      case "G":
        return <GoogleView onGooglePress={onGooglePress} />;
      case "A":
        return <Auth0View onAuth0Press={onAuth0Press} />;
      default:
        return (
          <SignupLoginView
            onSignupPress={onSignupPress}
            onLoginPress={onLoginPress}
            onFacebookPress={onFacebookPress}
            onGooglePress={onGooglePress}
            onSalesforcePress={onSalesforcePress}
            loginValidationText={loginValidationText}
            isLoginInProgress={isLoginInProgress}
            emailValidationText={emailValidationText}
            passwordValidationText={passwordValidationText}
          />
        );
    }
  }, [
    startObject,
    emailValidationText,
    passwordValidationText,
    loginValidationText,
  ]);

  return (
    <View
      style={{
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <View
        style={{
          alignSelf: "flex-start",
          justifyContent: "center",
          top: 30,
          left: 30,
          zIndex: 1,
        }}
      >
        <BackButton
          color={skalePrimaryBlue}
          onPress={() => {
            onBack("switch");
          }}
        />
      </View>
      {_handleShowContent()}
    </View>
  );
}
